module.exports = __webpack_public_path__ + "static/media/icn-nav-back.59c09701.svg";